export default function DownloadIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="download-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M24 30.95q-.4 0-.75-.15t-.65-.45l-7.85-7.85q-.6-.6-.575-1.425.025-.825.625-1.375.6-.6 1.4-.6.8 0 1.4.6l4.4 4.45V8q0-.85.575-1.425Q23.15 6 24 6q.85 0 1.425.575Q26 7.15 26 8v16.15l4.45-4.45q.6-.6 1.4-.6.8 0 1.4.6.6.55.6 1.375t-.6 1.425l-7.85 7.85q-.3.3-.675.45-.375.15-.725.15Zm-13.4 10.4q-1.65 0-2.825-1.175Q6.6 39 6.6 37.35v-6.4q0-.85.575-1.425.575-.575 1.425-.575.85 0 1.425.575.575.575.575 1.375v6.45h26.8V30.9q0-.8.575-1.375t1.425-.575q.8 0 1.375.575t.575 1.375v6.45q0 1.65-1.175 2.825Q39 41.35 37.4 41.35Z"
      />
    </svg>
  );
}
